export const links = [
  { to: "/", text: "Главная" },
  { to: "/tickets", text: "История" },
];
